import { Component, Input, OnInit } from '@angular/core';

import { FlightCategory } from '../models/flight-category.model';


@Component({
  selector: 'app-flight-category',
  templateUrl: './flight-category.component.html',
  styleUrls: ['./flight-category.component.scss']
})
export class FlightCategoryComponent implements OnInit {
  @Input() flightCategory: FlightCategory;

  constructor() { }

  ngOnInit() {
  }

  /**
   * Returns the flight category label to display to the user
   */
  get label(): string {
    return this.flightCategory ? this.flightCategory : '?';
  }

  /**
   * Returns a tooltip to display to the user when hovering over the flight category
   */
  get tooltip(): string {
    return this.flightCategory ? '' : 'Flight category unknown';
  }

  /**
   * Returns the CSS classes to set on the root element based on flight category
   */
  get cssClass(): Object {
    return {
      'flight-category--lifr': this.flightCategory === 'LIFR',
      'flight-category--ifr': this.flightCategory === 'IFR',
      'flight-category--mvfr': this.flightCategory === 'MVFR',
      'flight-category--vfr': this.flightCategory === 'VFR'
    };
  }
}
